import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { map, catchError, Observable } from 'rxjs';
import { Customer } from '../interfaces/customer';
import httpConfig from '../helpers/http-config';
import RedactCustomerRecords from '../interfaces/redactCustomerRecords';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

     constructor (private http: HttpClient) { }

     getExistingCustomer(customerName: string, countryAbbr: string, stateAbbr: string): Customer | any {
          if (customerName && countryAbbr && stateAbbr) {
               const url = `${environment.APP_API_URL}/api/v1/Customers/getCustomerMatch/{customerName}/{countryAbbr}/{stateAbbr}`
               .replace(`{${"customerName"}}`, encodeURIComponent(String(customerName)))
               .replace(`{${"countryAbbr"}}`, encodeURIComponent(String(countryAbbr)))
               .replace(`{${"stateAbbr"}}`, encodeURIComponent(String(stateAbbr)));
               return this.http.get(url, httpConfig())
                    .pipe(
                         map((response: Customer | null) => {
                              if (response) {
                                   const match = response as Customer;
                                   return match;
                              }
                              return null;
                         }),
                         catchError(error => {
                              console.error(error);
                              return [];
                         })
                    )

          } else {
               return null;
          }
     }

     getRedactCustomerRecords(customerId: number): RedactCustomerRecords | any {
          const url = `${environment.APP_API_URL}/api/v1/RedactRecords/redactRecordsForCustomer/{customerId}`
               .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));

          return this.http.get(url, httpConfig())
               .pipe(
                    map((response: RedactCustomerRecords | any) => {
                         if (response) {
                              const record = response as RedactCustomerRecords;
                              return record;
                         }
                         return null;
                    }),
                    catchError(error => {
                         console.error(error);
                         return [];
                    })
               );
     }

     setRecordMasking(maskRecords: boolean, customerId: string): RedactCustomerRecords | any {
          const url = `${environment.APP_API_URL}/api/v1/RedactRecords/setRedactRecords/{customerId}/{maskRecords}`
               .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
               .replace(`{${"maskRecords"}}`, encodeURIComponent(String(maskRecords)));
          return this.http.post(url, httpConfig())
               .pipe(
                    map((response: RedactCustomerRecords | any) => {
                         console.log(response)
                         if (response) {
                              const record = response as RedactCustomerRecords;
                              return record;
                         }
                         return null;
                    }),
                    catchError((error: any) => {
                         console.error(error);
                         return [];
                    })
               );
     }
}
